import { render, staticRenderFns } from "./IntegratedMarketingIndex.vue?vue&type=template&id=33e06d97&scoped=true"
import script from "./IntegratedMarketingIndex.vue?vue&type=script&lang=js"
export * from "./IntegratedMarketingIndex.vue?vue&type=script&lang=js"
import style0 from "./IntegratedMarketingIndex.vue?vue&type=style&index=0&id=33e06d97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e06d97",
  null
  
)

export default component.exports